import React, { useEffect, useState } from 'react';

function DailyReminder() {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const greetings = [
      "Take a deep breath 🌬️",
      "You are doing great 💪",
      "Be kind to yourself 💖",
      "Reflect and grow 🌱",
      "Today is a fresh start 🌞"
    ];
    const random = greetings[Math.floor(Math.random() * greetings.length)];
    setMessage(random);
  }, []);

  return (
    <div className="reminder-banner">
      {message}
    </div>
  );
}

export default DailyReminder;
